import styled from 'styled-components';

export const StyledSpinnerContainer = styled.div`
    display: flex;
    height: 75vh;
    flex-direction: column;
    align-items: center;
`;
